module.exports = "/assets/data/480e8c792f9afabf5d2e19094c88d2ad-DE23.data.json";